import { render, staticRenderFns } from "./PrivilegeCardMenu.vue?vue&type=template&id=6d28cf0e&scoped=true"
import script from "./PrivilegeCardMenu.vue?vue&type=script&lang=js"
export * from "./PrivilegeCardMenu.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeCardMenu.vue?vue&type=style&index=0&id=6d28cf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28cf0e",
  null
  
)

export default component.exports